<template>
    <nav class="secondary-nav-menu" aria-label="Filter menu">
        <ul class="list-unstyled list" ref="list">
            <li
                v-for="item in items"
                :key="item.text"
                class="list-item"
            >
                <b-button
                    size="sm"
                    variant="light"
                    :to="item.to"
                    v-test:itemBtn
                >
                    {{ item.text }}
                </b-button>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: 'secondary-nav-menu',

        props: {
            items: {
                type: Array,
                default: () => ([]),
            },

            selected: {
                type: String,
                default: 'view all',
            },
        },

        mounted() {
            this.putSelectedInView();
        },

        methods: {
            /**
             * Put the selected element in view.
             */
            putSelectedInView() {
                if (!process.client) {
                    return;
                }

                const el = this.$el.querySelector('.nuxt-link-exact-active');
                const list = this.$refs.list;

                if (!el || !list) {
                    return;
                }

                const bounding = el.getBoundingClientRect();

                if (bounding.left !== 0) {
                    list.scrollLeft += el.offsetLeft - 20;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .list {
        background-color: secondary-palette(8);
        display: flex;
        flex-wrap: nowrap;
        overflow: scroll;
        padding: 0 20px;
        scrollbar-width: 0;

        @include media-breakpoint-up(lg) {
            padding: 0;
            flex-direction: column;
            background-color: transparent;
            overflow: visible;
        }

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .list-item {
        @include media-breakpoint-up(lg) {
            margin-bottom: 19px;
        }
    }

    .btn {
        white-space: nowrap;
        padding-left: 12px;
        padding-right: 12px;
        min-width: unset;

        @include media-breakpoint-up(lg) {
            padding: $btn-padding-y $btn-padding-x;
            width: 100%;
            font-size: rem(20px);
            line-height: rem(24px);
            white-space: unset;
        }
    }

    .nuxt-link-exact-active {
        @include button-outline-variant(primary-palette(1));
        background: transparent;
    }
</style>
